import * as tslib_1 from "tslib";
import { IgrDefinitionBase } from "./igr-definition-base";
import { brushToString, stringToBrush } from "igniteui-react-core";
import { FontInfo } from "igniteui-react-core";
var IgrSummaryRow = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(IgrSummaryRow, _super);
    function IgrSummaryRow(props) {
        return _super.call(this, props) || this;
    }
    Object.defineProperty(IgrSummaryRow.prototype, "i", {
        /**
                                     * @hidden
                                     */
        get: function () {
            return this._implementation;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrSummaryRow.prototype, "selectedBackground", {
        /**
         * Gets or sets the background color for summary cells when selected.
        */
        get: function () {
            return brushToString(this.i.fi);
        },
        set: function (v) {
            this.i.fi = stringToBrush(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrSummaryRow.prototype, "actualSelectedBackground", {
        /**
         * Gets the actual background color for summary cells when selected.
        */
        get: function () {
            return brushToString(this.i.ff);
        },
        set: function (v) {
            this.i.ff = stringToBrush(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrSummaryRow.prototype, "summaryLabelTextColor", {
        /**
         * Gets or sets the text color for the summary labels.
        */
        get: function () {
            return brushToString(this.i.fj);
        },
        set: function (v) {
            this.i.fj = stringToBrush(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrSummaryRow.prototype, "actualSummaryLabelTextColor", {
        /**
         * Gets the actual text color for the summary labels.
        */
        get: function () {
            return brushToString(this.i.fg);
        },
        set: function (v) {
            this.i.fg = stringToBrush(v);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrSummaryRow.prototype, "summaryNameTextStyle", {
        /**
         * Gets or sets the text style for the summary labels.
        */
        get: function () {
            if (this.i.summaryNameTextStyle == null) {
                return null;
            }
            return this.i.summaryNameTextStyle.fontString;
        },
        set: function (v) {
            var fi = new FontInfo();
            fi.fontString = v;
            this.i.summaryNameTextStyle = fi;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrSummaryRow.prototype, "paddingLeft", {
        /**
         * Gets or sets the amount of left padding to use for the cell content for this column.
        */
        get: function () {
            return this.i.ev;
        },
        set: function (v) {
            this.i.ev = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrSummaryRow.prototype, "paddingTop", {
        /**
         * Gets or sets the amount of top padding to use for the cell content for this column.
        */
        get: function () {
            return this.i.ex;
        },
        set: function (v) {
            this.i.ex = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrSummaryRow.prototype, "paddingRight", {
        /**
         * Gets or sets the amount of right padding to use for the cell content of this column.
        */
        get: function () {
            return this.i.ew;
        },
        set: function (v) {
            this.i.ew = +v;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(IgrSummaryRow.prototype, "paddingBottom", {
        /**
         * Gets or sets the amount of bottom padding to use for the cell content of this column.
        */
        get: function () {
            return this.i.eu;
        },
        set: function (v) {
            this.i.eu = +v;
        },
        enumerable: true,
        configurable: true
    });
    return IgrSummaryRow;
}(IgrDefinitionBase));
export { IgrSummaryRow };
//# sourceMappingURL=igr-summary-row.js.map
